import { BrandLogo } from '../BrandLogo/BrandLogo'
import { Container } from './HeroPlaceholder.styles'

export const HeroPlaceholder = (): JSX.Element => {
  return (
    <Container>
      <BrandLogo.Extended variant="primary" />
    </Container>
  )
}
